import { FC } from 'react'
import styled, { useTheme } from 'styled-components'
import { Text } from '@/components/common'
import { LinkButton } from '@/components/common/buttons'
import { FontWeightEnum } from '@/constants/font-weight.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { LocationEnum } from '@/constants/location.enum'
import { useCustomRouter } from '@/containers/hooks'

type SubCategoryTabProps = {
  tabTitle: string
  categoryId?: string
  isActive: boolean
}

const SubCategoryTab: FC<SubCategoryTabProps> = ({ tabTitle, categoryId, isActive }) => {
  const { color } = useTheme()
  const { query } = useCustomRouter()
  const { brandId, rootCategoryId, orderBy } = query

  const createRipple = (event: any) => {
    const buttonElement = event.currentTarget
    let ripple = document.createElement('span')
    const size = buttonElement.offsetWidth
    const pos = buttonElement.getBoundingClientRect()

    ripple.style.width = ripple.style.height = `${size}px`
    ripple.style.left = `${event.clientX - pos.x - size / 2}px`
    ripple.style.top = `${event.clientY - pos.y - size / 2}px`
    ripple.classList.add('ripple')

    if (ripple) {
      ripple.remove()
    }
    buttonElement.appendChild(ripple)
  }

  return (
    <LinkButton
      url={{
        pathname: ROUTES.BRAND_DETAIL,
        query: {
          brandId: brandId,
          rootCategoryId: rootCategoryId,
          subCategoryId: categoryId,
          location: LocationEnum.Category,
          ...(orderBy && { orderBy }),
        },
      }}
      routeType="replace"
      shallow
    >
      <StyledSubCategoryTab
        onClick={(e) => {
          if (isActive) {
            return
          }
          createRipple(e)
        }}
      >
        <Text.Body3
          fontWeight={isActive ? FontWeightEnum.SemiBold : FontWeightEnum.Regular}
          fontColor={isActive ? color.gray900 : color.gray400}
        >
          {tabTitle}
        </Text.Body3>
      </StyledSubCategoryTab>
    </LinkButton>
  )
}

const StyledSubCategoryTab = styled.div`
  padding: ${({ theme: { spacing } }) => spacing.size12} ${({ theme: { spacing } }) => spacing.size18};
  position: relative;
  overflow: hidden;
  cursor: pointer;
`

export default SubCategoryTab
